import { render, staticRenderFns } from "./LendingRevolvingCreditInstalmentPlanSettingsCreate.vue?vue&type=template&id=758ba142&"
import script from "./LendingRevolvingCreditInstalmentPlanSettingsCreate.vue?vue&type=script&lang=ts&"
export * from "./LendingRevolvingCreditInstalmentPlanSettingsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VRow,VSwitch})
